import script from "./SeasonNumber.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SeasonNumber.vue?vue&type=script&lang=js"
export * from "./SeasonNumber.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SeasonNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/season-page/SeasonNumber.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d12bd10e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d12bd10e', __exports__)) {
    api.reload('d12bd10e', __exports__)
  }
  
}


export default __exports__